import { jsx as _jsx } from "react/jsx-runtime";
import { LinkBehaviourContext } from "@jti/ui";
import { ReactRouterLinkWrapper } from "../components/ReactRouterLinkWrapper";
export const LinkBehaviourContextProvider = ({ children }) => (_jsx(LinkBehaviourContext.Provider, { value: ReactRouterLinkWrapper, children: children }));
